var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showGradient)?_c('div',{staticClass:"tw-pointer-events-none tw-absolute tw-bottom-0 tw-left-0 tw-right-0 tw-z-20 tw-flex tw-h-16 tw-items-end tw-justify-center",style:({
    background:
      'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
  })},[(_vm.showArrow)?_c('v-btn',{staticClass:"tw-pointer-events-auto tw-transform",attrs:{"fab":"","x-small":""},on:{"click":_vm.scrollToBottom}},[_c('v-icon',[_vm._v("mdi-chevron-down")])],1):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }